export default {
	data() {
		return {
			payType: '', //支付方式
			detailsBox: true,
			paycenterXinxiisapprove: false,
			toPayBtn: true,
			dialogVisible: false,
            // 支付显示加载中
            loading: false,
		}
	},
	methods: {
		//嵌入支付宝页面
		isPay: function(data) {
			let end = data.indexOf('{"status"');
			let block = data.substring(0, end);
			let div = document.createElement('div');
			div.innerHTML = block;
			document.querySelector('#paycenter').appendChild(div);
			document.forms['alipaysubmit'].submit();
		},
		//选择不同支付方式
		goOrderDetails: function() {
            
            if(!this.payType){
                this.$message.warning('请选择支付方式')
                return
            }
            
            
            if(!this.$store.state.id){
                let model = document.querySelector('#modal-center');
                UIkit.modal(model).show();
                return
            }
			
            
            if (this.payType === 'alipay') {
                this.$post('users/rechargeBalanceByAlipay', { token: this.$store.state.id }).then(res => {
                    
                    if(res.data.status === 'fail'){
                        this.$message.warning(res.data.errorMsg)
                    }else{
                        this.isPay(res.data);
                    }
                    
                })
            } else if (this.payType === 'wxpay') {
                this.$post('users/rechargeBalanceByWechat', { token: this.$store.state.id}).then(res => {
                    if(res.data.status === 'fail'){
                        this.$message.warning(res.data.errorMsg)
                    }else{
                        this.$router.replace({
                            name: 'wechatpay',
                            params: {
                                wechatpay: res.data.result.pay_data,
                                balance_order_id: res.data.result.out_trade_no
                            }
                        });
                    }
                    
                })
            }
             else {
				let model = document.querySelector('#modal-pay');
				UIkit.modal(model).show();
			}
		},
		
		//选择支付方式
		changeBorder(who) {
			switch (who) {
				
				case 'zfb':
					this.payType = 'alipay';
					this.$refs.zfb.style.border = "1px solid #21a557";
					this.$refs.wx.style.border = "1px solid #cccccc";
					this.toPayBtn = true;
					this.$refs.zfbSjx.style.backgroundPosition = "0 -161px";
					this.$refs.wxSjx.style.backgroundPosition = "0 -187px";
					this.paycenterXinxiisapprove = false;
            
                    break;
				case 'wx':
					this.payType = 'wxpay';
					this.toPayBtn = true;
					this.$refs.zfb.style.border = "1px solid #cccccc"
					this.$refs.wx.style.border = "1px solid #21a557"
					this.$refs.zfbSjx.style.backgroundPosition = "0 -187px"
					this.$refs.wxSjx.style.backgroundPosition = "0 -161px"
					this.paycenterXinxiisapprove = false;
                    break;
			}
		},
        
		//跳转商品页面
		commodityDetails: function(id) {
			this.$router.push({
				path: '/classdetails',
				query: {
					id: id
				}
			});

		},


		// 获取当前的支付时间
		getPayDate() {
			let date = new Date()
			let year = date.getFullYear()
			let month = this.addZero(date.getMonth() + 1)
			let day = this.addZero(date.getDate())
			let hour = this.addZero(date.getHours())
			let minute = this.addZero(date.getMinutes())
			let second = this.addZero(date.getSeconds())
			return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
		},

		// 补0
		addZero(number) {
			if (number < 10) {
				return '0' + number
			} else {
				return number
			}
		}

	},
	created() {
		// console.log(this.$route.query);
		// let order_id=this.$route.query.order_id;
		// this.lastAddress='?id='+order_id+'&token?';
	},
	mounted() {
		document.title = '支付中心';
	},
}
